<template>
  <div>
    <div id="site-basket" class="callout" data-test-policy-price>
      <h2 class="heading1">
        {{ modelValue.Headline }}
      </h2>
      <div v-if="!editMode">
        <span :class="['total-price price', { 'text-faded': editMode && anyChanges }]">
          <span v-html="initialPriceFormatted" /><small
            ><span v-html="modelValue.PaymentPeriodLabel"
          /></small>
        </span>
      </div>
      <div v-else>
        <show-prices :modelValue="modelValue" />
        <p
          data-test-policy-price-disclaimer
          class="color-gray"
          v-html="modelValue.PriceDisclaimer"
        />
        <p
          v-if="hasAdditionalBasketProductInformationText"
          class="push-up"
          data-test-policy-additional-basket-product-information-text
          v-html="additionalBasketProductInformationText"
        />
        <p class="push-up" v-html="modelValue.ActivationDateExplenationLabel" />
      </div>

      <div>
        <div v-if="editMode" id="policy-basket-newprice" :class="{ 'push-up': !editMode }">
          <div v-if="editMode" class="row show-for-large push-up">
            <div class="small-5 columns">
              <button
                :disabled="!anyChanges || shouldBlock || loading"
                class="button align-center"
                data-test-policy-save-changes-button
                @click="$store.dispatch('policy/confirmSaveProposal')"
                v-html="modelValue.SaveButton"
              />
            </div>
            <div class="small-5 columns">
              <button
                :data-test-policy-cancel-edit-mode-button="portalId"
                class="button secondary align-center"
                @click="$store.dispatch('policy/cancelEditMode')"
                v-html="modelValue.CancelButton"
              />
            </div>
          </div>
        </div>
      </div>

      <p
        v-if="!editMode"
        data-test-policy-price-disclaimer
        class="color-gray"
        v-html="modelValue.PriceDisclaimer"
      />

      <p
        v-if="!editMode"
        data-test-policy-last-modified-date
        class="push-up"
        v-html="lastModified"
      />

      <activate-edit-mode-button
        :width="9"
        :show="basketFixed"
        :secondary="true"
        :disabled="!isEditingEnabled"
      />
    </div>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import ActivateEditModeButton from '../ActivateEditModeButton.vue';
import BasketMixin from './_BasketMixin';
import ShowPrices from './ShowPrices.vue';

export default {
  name: 'Price',
  components: {
    ActivateEditModeButton,
    ShowPrices
  },
  mixins: [BasketMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    lastModified() {
      return (
        this.modelValue.LatestChangesDateLabel + ' ' + this.modelValue.LastModifiedDateFormatted
      );
    },
    loading() {
      return this.$store.state.policy.loading;
    },
    inRenewal() {
      return this.$store.getters['policy/inRenewal'];
    },
    editModeButtonLabel() {
      return this.$store.getters['policy/editModeButtonLabel'];
    },
    isEditable() {
      return this.$store.getters['policy/isEditable'];
    },
    isEditingEnabled() {
      return this.$store.getters['policy/isEditingEnabled'];
    },
    portalId() {
      return this.$store.getters['policy/portalId'];
    }
  },
  mounted() {
    Utility.stickyBasket();
  }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.big-font {
  font-size: rem-calc(20px);
  font-weight: bold;
  line-height: rem-calc(20px);
}
</style>
